<app-instance-list [forceAccountSelectorForAdmin]="true" [forceAddInstanceForAdmin]="true"
    *ngIf="route.children.length === 0" [showAccount]="true"></app-instance-list>
<router-outlet></router-outlet>